import React from "react";

interface DragHandleProps {
  dragHandleRef: (node: HTMLElement | null) => void;
  dragHandleListeners: Record<string, unknown>;
  icon: React.ReactNode;
}

const DragHandle = ({
  dragHandleRef,
  dragHandleListeners,
  icon,
}: DragHandleProps): React.ReactElement => (
  <div
    ref={dragHandleRef}
    {...dragHandleListeners}
    style={{ cursor: "pointer" }}
  >
    {icon}
  </div>
);

export default DragHandle;
